import img1 from "../images/bautista/img1.jpg";
import img2 from "../images/bautista/img2.jpg";
import img3 from "../images/bautista/img3.jpg";
import img4 from "../images/bautista/img4.jpg";
import img5 from "../images/bautista/img5.jpg";
import img6 from "../images/bautista/img6.jpg";

export const imgBautista = [
  {
    id: 6101,
    image: img1
  },
  {
    id: 6102,
    image: img2
  },
  {
    id: 6103,
    image: img3
  },
  {
    id: 6104,
    image: img4
  },
  {
    id: 6105,
    image: img5
  },
  {
    id: 6106,
    image: img6
  }  
];